import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import getEmployeeInstructionAssignments from 'Education/api/instruction-assignment/getEmployeeInstructionAssignments';
import Loader from 'Common/components/Loader';
import useAxiosRequest from 'Common/hooks/useAxiosRequest';
import RetryLoading from 'Common/components/RetryLoading';
import AllInstructionAssignmentsTable from 'Employee/components/View/Instruction/AllInstructionAssignmentsTable';
import withRestrictionCheckDuringArchivingProcess from 'Education/components/common/withRestrictionCheckDuringArchivingProcess';
import OuterBox from 'Common/components/Boxes/OuterBox';

const Content = styled(OuterBox)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    padding: 8px 0;
`;

const LoaderWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

const AllEmployeeInstructionAssignments = () => {
    const instructionAssignmentsRequest = useCallback(
        cancelToken =>
            getEmployeeInstructionAssignments(
                undefined,
                [
                    'groupAssignmentDetails',
                    'groupAssignmentDetails.assignees.employee.user',
                ],
                cancelToken,
            ),
        [],
    );

    const {
        data: instructionAssignments,
        loadData: loadInstructionAssignments,
        isLoading,
        hasError,
    } = useAxiosRequest(instructionAssignmentsRequest, []);

    return (
        <Content>
            {isLoading ? (
                <LoaderWrapper>
                    <Loader />
                </LoaderWrapper>
            ) : hasError ? (
                <LoaderWrapper>
                    <RetryLoading onRetry={loadInstructionAssignments} />
                </LoaderWrapper>
            ) : (
                <AllInstructionAssignmentsTable
                    instructionAssignments={instructionAssignments}
                />
            )}
        </Content>
    );
};

export default withRestrictionCheckDuringArchivingProcess(
    AllEmployeeInstructionAssignments,
);
